import React, { useEffect, useState } from "react";
import { useApp } from "@/context/AppContext";
import { QuickBuy } from "@/components/order/QuickBuy";
import { OrderTicket } from "@/components/OrderTicket";

/** One entry point for trading: the simple amount-based buy for everyone, and the full
 *  ticket for a sell, a limit, a stop, or anyone who turned Pro mode on. */
export const TradeSheet = ({ open, onOpenChange, symbol, source = "global", onDone,
  initialSide = "buy", initialType = "market", maxQty }) => {
  const { user } = useApp();
  const advanced = !!user?.pro_mode || initialSide === "sell" || initialType !== "market";
  const [full, setFull] = useState(advanced);

  useEffect(() => { if (open) setFull(advanced); }, [open, advanced]);

  if (full) {
    return (
      <OrderTicket open={open} onOpenChange={onOpenChange} symbol={symbol} source={source}
        onDone={onDone} initialSide={initialSide} initialType={initialType} maxQty={maxQty} />
    );
  }
  return (
    <QuickBuy open={open} onOpenChange={onOpenChange} symbol={symbol} source={source}
      onDone={onDone} onMoreOptions={() => setFull(true)} />
  );
};
